import React, { useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useLanguage } from '../../context/LanguageContext';
import Modal from '../common/Modal';

const FEEDBACK_TYPES = [
  { value: 'incorrect', label: 'Antwort ist falsch' },
  { value: 'unclear', label: 'Antwort ist unklar' },
  { value: 'incomplete', label: 'Antwort ist unvollständig' },
  { value: 'irrelevant', label: 'Antwort ist irrelevant' },
  { value: 'other', label: 'Sonstiges' }
];

const FeedbackModal = ({ isOpen, onClose, onSubmit, isSubmitting }) => {
  const { t } = useLanguage();
  const [feedbackType, setFeedbackType] = useState('');
  const [feedbackText, setFeedbackText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ feedbackType, feedbackText });
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="max-w-sm mx-auto space-y-4">
        <h3 className="text-lg font-semibold text-white mb-4">
          {feedbackType === 'positive' ? t('positiveFeedback') : t('negativeFeedback')}
        </h3>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="feedbackType" className="block text-sm font-medium text-gray-300 mb-2">
              {t('feedbackTypeLabel')}
            </label>
            <select
              id="feedbackType"
              value={feedbackType}
              onChange={(e) => setFeedbackType(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white"
              required
            >
              <option value="" className="text-gray-400">Bitte wählen</option>
              {FEEDBACK_TYPES.map(type => (
                <option key={type.value} value={type.value} className="text-white">
                  {type.label}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="feedbackText" className="block text-sm font-medium text-gray-300 mb-2">
              {t('feedbackTextLabel')}
            </label>
            <textarea
              id="feedbackText"
              value={feedbackText}
              onChange={(e) => setFeedbackText(e.target.value)}
              className="w-full p-2 rounded bg-gray-700 text-white"
              rows="4"
              placeholder={t('feedbackTextPlaceholder')}
              required
            />
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-400 hover:text-white"
              disabled={isSubmitting}
            >
              {t('cancel')}
            </button>
            <button
              type="submit"
              disabled={isSubmitting || !feedbackType || !feedbackText}
              className={`px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-400 flex items-center ${
                isSubmitting || !feedbackType || !feedbackText ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {isSubmitting ? (
                <>
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  {t('sending')}
                </>
              ) : (
                t('submit')
              )}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default FeedbackModal;
